/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Online store
 */
export interface OnlineShopVO { 
    id?: number;
    code?: string;
    name?: string;
    categoryType?: string;
    channelTypeCode?: string;
    /**
     * Sales channel/platform type of the shop
     */
    channelType?: string;
    channelPlatform?: string;
    channelTypeMeaning?: string;
    status?: boolean;
    orgName?: string;
    onlineStoreTypeCode?: string;
    onlineStoreTypeMeaning?: string;
    url?: string;
    channelWarehouseStatus?: boolean;
    channelWarehouseName?: string;
    relationPhysicalShopName?: string;
    createdBy?: string;
    createdName?: string;
    creationDate?: string;
    objectVersionNumber?: number;
    physicalWarehouseId?: number;
    virtualWarehouseNames?: Array<string>;
    /**
     * Connection status of the channel integration
     */
    connectionStatus?: OnlineShopVO.ConnectionStatusEnum;
}
export namespace OnlineShopVO {
    export const ConnectionStatusEnum = {
        Connected: 'CONNECTED',
        NotConnected: 'NOT_CONNECTED',
        TempError: 'TEMP_ERROR'
    } as const;
    export type ConnectionStatusEnum = typeof ConnectionStatusEnum[keyof typeof ConnectionStatusEnum];
}


